export const PAYMENT_OPERATORS = {
	PAYU: 'payu',
	STRIPE: 'stripe',
	FAST_SPRING: 'fast_spring',
};
